export const createMeta = vm => ({
  title: `Cart - ${vm.storeInfo?.name}`,
  meta: {
    pageTitle: { name: 'Page Title', content: `Cart - ${vm.storeInfo?.name}` },
  },
})
